<template>
	<div class="content-edit-listing">
		<b-container fluid="xl">
			<b-row align-h="between" class="listing-detail-page-header">
				<b-col md="12" lg="6">
					<div class="add-listing-header">
						<div class="title">{{ $t('post') }}</div>
					</div>
				</b-col>
				<b-col md="12" lg="6" class="pd-lr-7 w340" align-self="center">
					<div class="wrap-btn text-right">
						<UserMenuDropdown v-if="$root.isAuthenticated" :userName="userName" />
						<b-button
							v-else
							id="openThairathLogin"
							@click="openThairathLogin"
							class="btn-login btn-item"
						>
							<IconLogin />
							{{ $t('login') }}
						</b-button>
					</div>
				</b-col>
			</b-row>
			<div class="steper-add-listing">
				<div class="divider"></div>
				<div class="stepper-circle">
					<div class="circle-title" v-bind:class="{ selected: firstStep }">
						<div class="circle">
							<PencilIcon />
						</div>
						<span class="title">{{ $t('addListing.details.details') }}</span>
					</div>
					<!-- <div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<MagnifyIcon />
						</div>
						<span class="title">{{ $t('addListing.preview.preview') }}</span>
					</div> -->
					<div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<CheckIcon />
						</div>
						<span class="title">{{ $t('addListing.neat.neat') }}</span>
					</div>
				</div>
			</div>
			<div class="add-listing-form">
				<!-- FIRST STEP -->
				<b-form class="form-search" v-if="firstStep">
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t('addListing.details.selectProductCategory')
						}}</label>
						<b-col cols="9">
							<b-row class="input-div">
								<!-- Main category -->
								<b-col cols="6" class="px-3">
									<b-button
										class="main-category-button"
										v-b-modal.modal-center
									>
										{{ $t(listing.mainCategory.name) }}
										<ChevronDownIcon />
									</b-button>
									<b-modal
										id="modal-center"
										centered
										hide-header
										hide-footer
										body-class="main-category"
									>
										<h4>
											{{ $t('addListing.details.selectProductCategory') }}
										</h4>
										<div class="select-categories">
											<div
												class="category-div"
												@click="
													hideModal(
														'modal-center',
														key + 1,
														value.id,
														value.name,
														value
													)
												"
												v-for="(value, key) in categoriesOptions"
												v-bind:key="key"
											>
												<div v-html="value.url_icon2" class="icon-div"></div>
												<h5>{{ $t(value.name) }}</h5>
											</div>
										</div>
									</b-modal>
								</b-col>
								<!-- Sub category -->
								<b-col cols="6" class="px-3">
									<b-dropdown no-flip
										:class="{
											'input-error': validateErrors
												? validateErrors.idSubListing
												: false
										}"
										class="menu-dropdown"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.subCategory
														? $t(listing.subCategory.name)
														: $t('addListing.details.selectSubCategory')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="category in childCategories.listing_category_children"
											:key="category.id"
											@click="listing.subCategory = category"
											>{{ $t(category.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
							</b-row>
						</b-col>
					</div>
					<!-- Product name -->
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_title)
						}}</label>
						<div class="input-div col-9">
							<b-form-input
								:placeholder="$t(childCategories.field_name_title)"
								class="input-search form-control"
								:class="{
									'input-error': validateErrors ? validateErrors.title : false
								}"
								v-model="listing.title"
							></b-form-input>
						</div>
					</div>
					<!-- Attributes -->
					<template
						v-for="(item, key) in childCategories.category_attribute_details"
					>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Radio button'
							"
						>
							<div class="input-div-for-rent-sale col-12">
								<label class="col-3 required-label">{{
									$t(item.listing_attribute.name)
								}}</label>
								<b-form-radio-group
									class="sale-rent-radio"
									:name="`radio-sub-component-${key + 1}`"
									v-for="(value, k) in item.listing_attribute
										.listing_pre_values"
									:key="k"
									@change="
										changeRadioValue($event, `radioValue_${item.attr_id}`)
									"
									v-model="
										listing.listingAttr.data[`radioValue_${item.attr_id}`]
									"
								>
									<b-form-radio :value="value.id">{{
										$t(value.value)
									}}</b-form-radio>
								</b-form-radio-group>
								<span v-if="item.id==1||item.id==135" style="position: absolute;right: 209px;">
								<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor) !important;"/>
								<b-tooltip
									custom-class="website-tool-tips"
									placement="righttop"
									target="price-info"
								>
									{{$t('rentOrSaleNote', selectedLangugae)}}
								</b-tooltip>
								</span>
							</div>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type == 'Textbox'
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<b-col cols="9">
								<div class="input-div row">
									<b-col cols="6" class="pl-15">
										<b-form-input
											:placeholder="$t(item.listing_attribute.placeholder)"
											class="input-search form-control"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:min="item.listing_attribute.min"
											:max="item.listing_attribute.max"
										></b-form-input>
									</b-col>
									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15"
									>
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
											<div
												v-if="
													value.listing_attributes_type.type == 'Select option'
												"
											>
												<b-dropdown no-flip
													class="menu-dropdown"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
													<template v-slot:button-content>
														<span>
															{{
																$t(dropdownChooseValue[
																	`selectValue_${item.attr_id}`
																])
															}}
															<ChevronDownIcon />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, k) in value.listing_pre_values"
														:key="k"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[
																`selectValue_${item.attr_id}`
															] = val.value;
														"
														>{{ $t(val.value) }}</b-dropdown-item
													>
												</b-dropdown>
											</div>
											<div
												v-else-if="
													value.listing_attributes_type.type == 'Textbox'
												"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Select option'
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<div class="single-select input-div col-9">
								<b-dropdown no-flip
									class="menu-dropdown"
									:class="{
										'input-error':
											isValidate &&
											!validateInputDynamic.some(
												temp => temp === `selectValue_${item.attr_id}`
											),
										'full-width': listing.mainCategory.idCategory == 4
									}"
								>
									<template v-slot:button-content>
										<span>
											{{ $t(dropdownChooseValue[`selectValue_${item.attr_id}`]) }}
											<ChevronDownIcon />
										</span>
									</template>
									<b-dropdown-item
										v-for="(value, k) in item.listing_attribute
											.listing_pre_values"
										:key="k"
										@click="
											listing.listingAttr.data[`selectValue_${item.attr_id}`] =
												value.id;
											dropdownChooseValue[`selectValue_${item.attr_id}`] =
												value.value;
										"
										>{{ $t(value.value) }}</b-dropdown-item
									>
								</b-dropdown>
							</div>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Number' && !listing.listingAttr.data.radioValue_18
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<b-col cols="9">
								<div class="input-div row">
									<b-col cols="6" class="pl-15">
										<masked-input
											type="text"
											class="input-search price-input form-control"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.placeholder)"
										></masked-input>
									</b-col>

									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15"
									>
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
											<div
												v-if="value.listing_attributes_type.type == 'Textbox'"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
												></b-form-input>
											</div>
											<div
												v-if="value.listing_attributes_type.type == 'Number'"
											>
												<masked-input
													type="text"
													class="input-search price-input form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.placeholder)"
												></masked-input>
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>
						<div
							class="form-group row"
							:key="key"
							v-if="
								item.listing_attribute.listing_attributes_type.type ==
									'Number' && listing.listingAttr.data.radioValue_18 == 56
							"
						>
							<label class="col-3 required-label">{{
								$t(item.listing_attribute.name)
							}}</label>
							<b-col cols="9">
								<div class="input-div row">
									<b-col cols="6" class="pl-15">
										<masked-input
											type="text"
											class="input-search price-input form-control"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.placeholder)"
										></masked-input>
									</b-col>

									<b-col
										v-if="
											item.listing_attribute.listing_attributes_children.length
										"
										cols="6"
										class="pr-15"
									>
										<div
											v-for="(value, key) in item.listing_attribute
												.listing_attributes_children"
											:key="key"
										>
											<div
												v-if="value.listing_attributes_type.type == 'Textbox'"
											>
												<b-form-input
													:placeholder="$t(value.placeholder)"
													class="input-search form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:min="item.listing_attribute.min"
													:max="item.listing_attribute.max"
												></b-form-input>
											</div>
											<div
												v-if="value.listing_attributes_type.type == 'Number'"
											>
												<masked-input
													type="text"
													class="input-search price-input form-control"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.placeholder)"
												></masked-input>
											</div>
										</div>
									</b-col>
								</div>
							</b-col>
						</div>
					</template>
					<!-- Price -->
					<div
						class="form-group row"
						v-if="
							listing.mainCategory.key != '4' &&
								listing.mainCategory.idCategory != 4
						"
					>
						<label class="col-3 required-label">{{
							$t('addListing.details.price')
						}}</label>
						<div
							class="price-input-div"
							:class="{
								'input-error': validateErrors ? validateErrors.price : false
							}"
						>
							<masked-input
								type="text"
								class="input-search price-input"
								v-model="listing.price"
								:mask="numberAmountMask()"
								:placeholder="$t('addListing.details.price')"
							></masked-input>
							<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor)!important;"/>
							<b-tooltip
								custom-class="website-tool-tips"
								placement="righttop"
								target="price-info"
							>
								{{$t('Please enter the actual product price Failure to do so will result in an offense under the Notification of the Central Committee on Prices of Goods and Services No 102 B E 2562')}}
							</b-tooltip>
						</div>
					</div>
					<!-- Image -->
					<div class="form-group make-label-start row">
						<label class="col-3 required-label">{{
							$t('addListing.details.productImages')
						}}</label>
						<div class="input-div col-9">
							<Fileuploader
								name="files"
								:maxFiles="
									listing.mainCategory.key == 2 || listing.mainCategory.key == 3
										? '10'
										: '6'
								"
								:class="{
									'input-error': validateErrors
										? validateErrors.imageError
										: false
								}"
								:accept="'jpg, png, jpeg'"
								:hideFileUploader="hideFileUploader"
								:multiple="true"
								@childToParent="getFile"
								:fileUploaded="arrImageUploaded"
								:theme="'thumbnails'"
								:changeInput="' '"
							/>
							<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Recommend picture size 1200x675 pixel - For "Free" listings, limit is 6 total photos')}}</p>
						</div>
					</div>
					<!-- Description -->
					<div class="form-group description make-label-start row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_description)
						}}</label>
						<div class="input-div col-9">
							<b-form-textarea
								:placeholder="$t(childCategories.field_name_description)"
								class="input-search"
								:class="{
									'input-error': validateErrors
										? validateErrors.description
										: false
								}"
								v-model="listing.description"
							></b-form-textarea>
						</div>
					</div>
					<!-- Keywords -->
					<div class="form-group row">
						<label class="col-3">{{ $t('addListing.details.keywords') }}</label>
						<div class="input-div col-9">
							<b-form-tags
								input-id="tags-validation"
								:input-attrs="{
									'aria-describedby': 'tags-validation-help'
								}"
								separator=" ,;"
								remove-on-delete
								:tag-validator="tagValidator"
								v-model="listing.keywords"
								class="mb-2"
								tag-pills
								size="md"
								:placeholder="$t('addListing.details.keywordsPlaceholder')"
								isDuplicate="false"
							></b-form-tags>
							<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Please fill keywords relate with your listing for customer searching and found you listing')}}</p>
						</div>
					</div>
					<!-- google maps -->
					<!-- <div class="form-group row" v-if="listing.mainCategory.idCategory==2">
						<label class="col-3 required-label">{{$t('addListing.details.Address')}}</label>
						<b-col cols="7" class="pr-0">
							<div class="input-div row no-gutters">
								<b-form-input
									:placeholder="$t('addListing.details.Address')"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.phoneAndEmail
											: false
									}"
									v-model="loclationAddress"
									disabled
									style="border-bottom-right-radius: 0; border-top-right-radius: 0;"
								></b-form-input>
							</div>
						</b-col>
						<b-col cols="2" class="pl-0">
							<div class="input-div row no-gutters">
								<div class="show-google-maps" v-b-modal.showgooglemap-model>{{$t('addListing.details.showOnMap')}}</div>
							</div>
							<div class="note-div notes">
								<span>
									{{$t('addListing.details.showOnMapNote')}}
								</span>
							</div>
						</b-col>
						
						<b-modal
							id="showgooglemap-model"
							class="listing-preview-dialog"
							title="Preview Listing"
							size="xl"
							scrollable
							hide-footer
							hide-header
							ref="showgooglemap-model"
							center
						>
							<google-map
									ref="mapRef"
									:center="{ lat: lat, lng: lng }"
									:zoom="12"
									style="width: 100%;height:50vh"
                  					@click="putMarker($event)"
									:options="{
										zoomControl: true,
										mapTypeControl: false,
										scaleControl: true,
										streetViewControl: false,
										rotateControl: false,
										fullscreenControl: false,
										disableDefaultUI: true
									}"
								>
									<google-marker
										ref="myMarker"
										:position="
											google &&
												new google.maps.LatLng(markerLat, markerLng)
										"
                    					:draggable="true"
										:clickable="true"
										:animation="1"
										@position_changed="getPosition($event)"
										@click="getPosition($event)"
									></google-marker>
								</google-map>
								<div style="color:red">
									{{$t('addListing.details.mapNote')}}
								</div>
								<div class="footer">
									<b-button class="okay-button success-button mr-5" style="width:150px;"  variant="success" @click="ok()">{{$t('addListing.details.ok')}}</b-button>
									<b-button class="cancel-button mr-5" style="width:150px;"  variant="danger" @click="cancel()">{{$t('addListing.details.cancel')}}</b-button>
									
								</div>
						</b-modal>
					</div> -->
					<!-- Province / District -->
					<div class="form-group row">
						<label class="col-3 required-label">{{
							$t(childCategories.field_name_location)
						}}</label>
						<b-col cols="9">
							<div class="input-div row">
								<b-col cols="6" class="px-3">
									<b-dropdown no-flip
										class="menu-dropdown"
										:class="{
											'input-error': validateErrors
												? validateErrors.state
												: false
										}"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.state
														? $t(listing.state.name)
														: $t('addListing.details.province')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="(province, key) in arrListProvince"
											v-bind:key="key"
											@click="handleProvinceChange(province)"
											>{{ $t(province.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
								<b-col cols="6" class="px-3">
									<b-dropdown no-flip
										class="menu-dropdown"
										:disabled="!listing.state"
										:class="{
											'input-error': validateErrors
												? validateErrors.district
												: false
										}"
									>
										<template v-slot:button-content>
											<span>
												{{
													listing.district
														? $t(listing.district.name)
														: $t('addListing.details.district')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											v-for="(district, key) in arrListDistrict"
											v-bind:key="key"
											@click="listing.district = district"
											>{{ $t(district.name) }}</b-dropdown-item
										>
									</b-dropdown>
								</b-col>
							</div>
						</b-col>
					</div>
					<!-- Contact -->
					<div class="form-group make-label-start row">
						<label class="col-3">{{
							$t('addListing.details.contactDetails')
						}}</label>
						<b-col cols="9">
							<div class="email-div row">
								<b-col cols="12">
									<b-form-checkbox v-model="listing.takeContactFromDashboard">{{
										$t('addListing.details.takeFromDashboard')
									}}</b-form-checkbox>
								</b-col>
								<b-col cols="12" style="padding-right:0">
									<div class="input-div row no-gutters" >
										<b-col cols="6" style="padding:0;padding-left:8px;">
											<b-form-input
												:placeholder="$t('user.email')"
												class="input-search"
												:class="{
													'input-error': validateErrors
														? validateErrors.phoneAndEmail
														: false
												}"
												v-model="listing.email"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
										<b-col cols="6" class="px-3" style="padding-right:0">
											<b-form-input
												:placeholder="$t('phone number (only numbers)')"
												class="input-search"
												:class="{
													'input-error': validateErrors
														? validateErrors.phoneAndEmail
														: false
												}"
												type="number"
												v-model="listing.phoneNumber"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
									</div>
								</b-col>
							</div>
						</b-col>
					</div>
					<div class="form-group make-label-start row">
						<label class="col-3 p-0">{{
							$t('line')
						}}
						<img src="/images/line.png" style="width: 35px;height:35px; margin-left: 10px;margin-right: 20px;margin-top: 5px;" alt="line"/>
						</label>
						<b-col cols="9">
							<div class="email-div row">
								<b-col cols="12">
									<div class="input-div row no-gutters">
										<b-col cols="6" style="padding:0;padding-left:8px;">
											<b-form-input
												:placeholder="$t('line')"
												class="input-search"
												v-model="listing.line_id"
												:disabled="listing.takeContactFromDashboard"
												style="width: 333px;"
											></b-form-input>
										</b-col>
									</div>
								</b-col>
							</div>
						</b-col>
					</div>
					<!-- Packages -->
					<b-modal
						id="package-model"
						class="package-model"
						title="Preview Listing"
						size="xl"
						scrollable
						hide-footer
						hide-header
						ref="package-model"
						center
						no-close-on-backdrop
						no-close-on-esc
						>
						<div class="package-model">
							<Packages
								v-if="arrUserPayment || $route.name === 'AddListing'"
								@childToParent="getSelectedPackages"
								:userPayment="arrUserPayment"
								:website="listing.website"
							/>
							<div class="footer">
								<!-- Emulate built in modal footer ok and cancel button actions addPackage(true)-->
								<b-button class="cancel-button mr-5" style="width:150px;border: 1px solid var(--projectPrimaryColor)!important;background-color: white!important;color: var(--projectPrimaryColor) !important;"  variant="danger" 
									@click="toggleAdsImag()">{{$t('addListing.details.skipPackage')}}</b-button>
								<b-button class="okay-button success-button mr-5" style="width:150px;"  variant="success" 
								@click="addPackage(false)" :disabled="disabledPackageButton">{{$t('addListing.details.ok')}}</b-button>
								<!-- Button with custom close trigger value -->
							</div>
							
						</div>
					</b-modal>
					<b-modal
						id="image-ads-model"
						class="image-ads-model"
						hide-footer
						hide-header
						ref="image-ads-model"
						centered
						size="md"
						no-close-on-backdrop
						no-close-on-esc
						>
							
							<div style="position: relative;">
								<img :src="'/images/popup/ads-image-'+selectedLanguage+'.png'"/>
								<img :src="'/images/popup/upgrade.png'"
								style="position: absolute;right: -31px;top:34px;cursor: pointer;" @click="openPakcageDialog()"/>
								<img :src="'/images/popup/no-'+selectedLanguage+'.png'"  
								style="position: absolute;left: 50px;bottom: 45px;cursor: pointer;" @click="addPackage(true)"/>
								<img :src="'/images/popup/yes-'+selectedLanguage+'.png'"
								style="position: absolute;right: 20px;bottom: 34px;cursor: pointer;" @click="openPakcageDialog()"/>
								
							</div>
					</b-modal>
					
					<!-- Submit btn -->
					<div class="button-div">
						<div>
							{{ $t('addListing.details.clickPostToAccept') }}
							<router-link id="goHome" :to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"><span>{{ $t('addListing.details.termsCondition') }}</span></router-link>
						</div>
						<b-button
							type="button"
							class="btn-submit-search"
							@click="openPakcageDialog()"
							:disabled="disabled"
							>{{ $t('addListing.details.post') }}</b-button
						>
					</div>

					<b-modal
						id="listing-preview-dialog-first"
						centered
						hide-footer
						hide-header
						size="lg"
						no-close-on-backdrop
					>
						<b-container fluid>
							<div class="preview-div">
								<div class="icon-div">
									<IconClipboardText />
								</div>

								<h4>{{ $t('addListing.details.listingUnderReview') }}</h4>
								<!-- <p style="margin-bottom:0;">{{ $t('addListing.details.listingPreviewText') }}</p> -->
								<p style="margin-bottom:0;">
									{{$t('please click')}}
									<b>{{$t('Confirm the announcement')}}</b> {{$t('to complete the posting process')}}
								</p>
								<p>{{ $t('addListing.details.listingPreviewText1') }}</p>
								<div class="button-div">
									<b-button
										class="btn-submit-search extra-background-color-button"
										@click="previousEditListing"
										>{{ $t('addListing.details.editProductButton') }}</b-button
									>
									<b-button
										type="submit"
										class="btn-submit-search extra-background-color-button"
										@click="previewAddListing"
										id="previewListing"
										>{{ $t('addListing.details.previewButton') }}</b-button
									>
									<b-modal
										id="preview-model"
										class="listing-preview-dialog"
										title="Preview Listing"
										size="xl"
										scrollable
										hide-header
										no-close-on-backdrop
									>
										<ListingDetail :listingDetailsFront="arrListPreview" />
										<template v-slot:modal-footer="{ ok }">
											<div class="footer">
												<!-- Emulate built in modal footer ok and cancel button actions -->
												
												<!-- <b-button
													class="extra-background-color-button"
													@click="
														cancel();
													"
													style="border:1px solid var(--projectPrimaryColor)!important; color: var(--projectPrimaryColor)!important;
													width: 178px;
													border-radius: var(--borderRadius);
													margin-right: 25px;
													margin-top: 22px;"
													>Cancel</b-button
												> -->
												<b-button
													class="btn-submit-search"
													@click="
														ok();
													"
													style="background: var(--projectPrimaryColor)!important; color:white;
													width: 178px;
													border-radius: var(--borderRadius);
													margin-right: 25px;
													margin-top: 22px;"
													>ปิด</b-button
												>
												<!-- Button with custom close trigger value -->
											</div>
										</template>
									</b-modal>
									<!-- v-on:click="previewDialog();secondStep = true;firstStep=false;" -->
									<b-button
										type="submit"
										class="btn-submit-search"
										v-on:click="skipAddListing"
										id="confirmAddListing"
										>{{ $t('addListing.details.skipButton') }}</b-button
									>
								</div>
							</div>
						</b-container>
					</b-modal>
				</b-form>

				<!-- SECOND STEP -->

				<!-- THIRD STEP -->
				<div class="review-listing" v-else-if="secondStep">
					<div class="icon-div">
						<ClockOutlineIcon />
					</div>
					<p>{{ $t('addListing.details.reviewText') }}</p>
					<div class="wrap-redirect-btn">
						<router-link id="goHome" :to="$i18nRoute({ name: '' })">
							<b-button class="go-home">{{$t('back to home page')}}</b-button>
						</router-link>
						<router-link
							id="goDashboard"
							:to="$i18nRoute({ name: 'user-dashboard' })"
						>
							<b-button class="go-dashboard">{{$t('go to control panel')}}</b-button>
						</router-link>
					</div>
				</div>
			</div>
		</b-container>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { gmapApi } from 'vue2-google-maps';
import MaskedInput from 'vue-text-mask';

import UserMenuDropdown from '@/components/ui/UserMenuDropdown';
import ListingDetail from '@/components/listing/listingDetail/ListingDetail';

// Icons
import { BIconQuestionCircle } from 'bootstrap-vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import Packages from '@/components/packages/Packages';
import Fileuploader from '@/components/newFileuploader/index';
import IconClipboardText from '@/components/icons/IconClipboardText/index';
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import IconLogin from '@/components/icons/IconLogin/index';
import { Trans } from '@/plugins/Translation';

export default {
	components: {
		BIconQuestionCircle,
		PencilIcon,
		// MagnifyIcon,
		CheckIcon,
		Packages,
		Fileuploader,
		IconClipboardText,
		ClockOutlineIcon,
		ListingDetail,
		ChevronDownIcon,
		IconLogin,
		MaskedInput,
		UserMenuDropdown
	},
	data() {
		return {
			disabledPackageButton:true,
			lat: 13.7563,
      		lng: 100.5018,
			gmapApi:null,
			map: null,
			markerLat: 13.7563,
			markerLng: 100.5018,
			loclationAddress:null,
			disabled: false,
			hideFileUploader: false,
			categoryFirstChange: false,
			provinceFirstChange: false,
			firstStep: true,
			secondStep: false,
			thirdStep: false,
			listing: {
				phoneNumber: null,
				line_id: null,
				takeContactFromDashboard: true,
				email: null,
				price: null,
				description: null,
				keywords: null,
				state: null,
				district: null,
				mainCategory: {
					key: 1,
					idCategory: null,
					name: null
				},
				subCategory: null,
				title: null,
				listingAttr: {
					data: {}
				},
				package_detail_ids: '',
				affiliate_dates_ids: '',
				listingImage: [],
				website: null,
				listing_category_id: null
			},
			childCategories: {},
			dropdownChooseValue: {},
			listListingJustCreated: {},
			validateErrors: {},
			validateInputDynamic: [null],
			isValidate: false,
			countError: 0,
			arrImageUploaded: [],
			arrUserPayment: null,
			loading:false,
			userName:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).display_name
					? JSON.parse(localStorage.getItem('user_profile')).display_name
					: '',
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false
		};
	},
	computed: {
		...mapGetters('AddListingController', ['arrListProvince', 'valueRedirect']),
		...mapState('AddListingController', [
			'arrListDistrict',
			'arrListCategoryChild',
			'arrListPreview',
			'listingJustCreated'
		]),
		...mapGetters('CategoryController', ['categoriesOptions']),
		google: gmapApi,
		selectedLanguage(){
			return Trans.currentLanguage
		}
	},
	created() {
		this.GET_CATEGORY();

		this.GET_LIST_PROVINCES({
			take: -1,
			page: 1
		});
		// Get the listing details if in edit mode
		if (this.$route.name === 'EditListing') {
			this.getListingEdit();
		} else {
			this.GET_CATEGORY_CHILD_BY_ID(this.listing.mainCategory.key);
			this.getContactDetails();
		}
	},
	mounted() {
		if(!this.$root.isAuthenticated){
			this.$root.signIn('add-listing');
		}
		if (this.valueRedirect) {
			this.firstStep = false;
			// this.secondStep = false;
			this.secondStep = true;
			this.$store.commit(
				'AddListingController/VALUE_WHEN_REDIRECT_ADD_LISTING',
				false
			);
		}
		this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
			if (modalId == 'modal-center') {
				// this.hideFileUploader = false;
			}
		});
	},
	watch: {
		'listing.package_detail_ids'(val){
			console.log('val',typeof val)
			if(val.length){
				
				if(val.indexOf(10)>-1&&!this.listing.website){
					this.disabledPackageButton=true;
					this.$forceUpdate();
				}else{
					
					this.disabledPackageButton=false;
					this.$forceUpdate();
					console.log("this.disabledPackageButton",this.disabledPackageButton)
				}
				console.log("if this.disabledPackageButton",this.disabledPackageButton)
			}else{
				this.disabledPackageButton=true;
				this.$forceUpdate();
				console.log("this.disabledPackageButton",this.disabledPackageButton)
			}
		},
		'listing.website'(val){
			if (val.match('https://') || val.match('http://')) {
				this.disabledPackageButton = false;
				this.$forceUpdate();
				return;
			} else {
				this.disabledPackageButton = true;
				this.$forceUpdate();
			}
		},
		// 'Hacky' way (render error otherwise) need a proper loading management
		arrListCategoryChild(val) {
			this.childCategories = val;
		},
		'arrListCategoryChild.listing_category_children'(newVal) {
			if (this.$route.name === 'AddListing' || this.categoryFirstChange) {
				this.listing.subCategory = {
					id: newVal[0].id,
					name: newVal[0].name
				};
			}
		},
		categoriesOptions(val) {
			this.listing.mainCategory.idCategory = val[0].id;
			this.listing.mainCategory.name = val[0].name;
		},
		arrListDistrict(newVal) {
			//  Set default value if in addListing or the province is changed
			if (this.$route.name === 'AddListing' || this.provinceFirstChange) {
				this.listing.district = newVal[0];
			}
		},
		'listing.takeContactFromDashboard': function(val) {
			if (val) {
				this.getContactDetails();
			}
		},
		'listing.state': function(data) {
			this.GET_LIST_DISTRICTS({
				take: -1,
				page: 1,
				province_id: data.id
			});
		},
		'listing.mainCategory.idCategory': function(idCategory) {
			this.GET_CATEGORY_CHILD_BY_ID(idCategory);
		},

		listingJustCreated: function(val) {
			this.listListingJustCreated = val;
		},
		'arrListCategoryChild.category_attribute_details'(val) {
			//  Set default value if in addListing or main category is changed
			if (this.$route.name === 'AddListing' || this.categoryFirstChange) {
				this.fillAttributes(val);
			}
		},
		arrListPreview(val) {
			this.arrImageUploaded = [];
			this.$forceUpdate();
			this.listing.mainCategory = {
				idCategory: val.listing_category.listing_category_parent.id,
				name: val.listing_category.listing_category_parent.name
			};
			this.listing.subCategory = {
				id: val.listing_category.id,
				name: val.listing_category.name
			};
			this.listing.title = val.title;
			this.listing.price = val.price.toString();
			this.listing.description = val.description;
			this.listing.state = val.province;
			this.listing.district = val.district;
			this.listing.phoneNumber = val.phone;
			this.listing.line_id = val.line_id;
			this.listing.email = val.email;
			this.listing.website = val.website;
			if (val.keywords) {
				let arrKeywords = val.keywords.split(',');
				this.listing.keywords = arrKeywords;
			}
			if (val.user_payments.length) {
				
				let result = val.user_payments.filter(
					(temp) =>
						temp.status == 1 ||
						temp.status == 2 ||
						temp.status == 4 ||
						temp.status == 7
				);
				if (result) {
					this.arrUserPayment = [];
					let arr = [];
					let datesArr = [];
					result.forEach(payment => {
						console.log('RESULT ', payment.user_payments_details);
						this.arrUserPayment.push(payment.user_payments_details);
						payment.user_payments_details.forEach(elm=>{
							if (elm.package_detail_id) {
								arr.push(elm.package_detail_id);
							}
						})
						if(payment.affiliate_book_dates.length){
							payment.affiliate_book_dates.forEach(date => {
								datesArr.push(date.id);
							});
						}
						
					});
					this.listing.package_detail_ids = arr.toString();
					this.listing.affiliate_dates_ids = datesArr.toString();
					console.log('this.listing.package_detail_ids ', this.listing.package_detail_ids);
					this.listing.user_payments=val.user_payments;
					this.listListingJustCreated.user_payments=val.user_payments;
					this.arrUserPayment = result;
				} else {
					this.arrUserPayment = [];
					this.listing['user_payments']=[];
					this.listListingJustCreated['user_payments']=[];
				}
			} else {
				this.arrUserPayment = [];
				this.listing['user_payments']=[];
				this.listListingJustCreated['user_payments']=[];
			}
			if (val.url_feature_image) {
				this.arrImageUploaded.push(val.url_feature_image);
			}
			if (val.listing_images.length) {
				val.listing_images.map(value => {
					this.arrImageUploaded.push(value.url_image);
				});
			}
			for (const item of val.listing_attributes_details) {
				if (
					item.listing_attribute.listing_attributes_type.id == 1 ||
					item.listing_attribute.listing_attributes_type.id == 4
				) {
					this.listing.listingAttr.data[`inputValue_${item.attr_id}`] =
						item.value;
				}
				if (item.listing_attribute.listing_attributes_type.id == 2) {
					this.listing.listingAttr.data[`radioValue_${item.attr_id}`] =
						item.pre_values_id;
				}
				if (item.listing_attribute.listing_attributes_type.id == 3) {
					this.listing.listingAttr.data[`selectValue_${item.attr_id}`] =
						item.pre_values_id;
					this.dropdownChooseValue[`selectValue_${item.attr_id}`] =
						item.listing_pre_value.value;
				}
			}
		},
		'listing.keywords': function(val) {
			if (val.length > 5) {
				this.listing.keywords.length = 5;
				this.makeToastError(this.$t('editListing.keywords.maxKeyword'));
			}
		},
		isLogin: function(val) {
			if (val) {
				setTimeout(() => {
					this.userName = JSON.parse(
						localStorage.getItem('user_profile')
					).display_name;
				}, 500);
			}
		}
	},
	methods: {
		...mapActions('AddListingController', [
			'GET_LIST_PROVINCES',
			'GET_LIST_DISTRICTS',
			'GET_CATEGORY_CHILD_BY_ID',
			'USER_ADD_LISTING',
			'GET_LISTING_PREVIEW',
			'USER_UPDATE_LISTING',
			'USER_CONFIRM_LISTING'
		]),
		...mapActions('CategoryController', ['GET_CATEGORY']),

		getContactDetails() {
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).email
			) {
				this.listing.email = JSON.parse(
					localStorage.getItem('user_profile')
				).email;
			}
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).telephone
			) {
				this.listing.phoneNumber = JSON.parse(
					localStorage.getItem('user_profile')
				).telephone;
			}
			if (
				localStorage &&
				JSON.parse(localStorage.getItem('user_profile')).line_id
			) {
				this.listing.line_id = JSON.parse(
					localStorage.getItem('user_profile')
				).line_id;
			}
		},

		handleProvinceChange(province) {
			this.listing.state = province;
			this.provinceFirstChange = true;
		},

		fillAttributes(array) {
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			this.validateInputDynamic = [];
			for (const item of array) {
				if (item.listing_attribute.listing_attributes_type.id == 2) {
					this.listing.listingAttr.data[`radioValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].id;
				} else if (item.listing_attribute.listing_attributes_type.id == 3) {
					this.listing.listingAttr.data[`selectValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].id;
					this.dropdownChooseValue[`selectValue_${item.attr_id}`] =
						item.listing_attribute.listing_pre_values[0].value;
				} else if (item.listing_attribute.listing_attributes_type.id == 1) {
					for (const child of item.listing_attribute
						.listing_attributes_children) {
						if (child.listing_attributes_type.id === 3) {
							this.listing.listingAttr.data[`selectValue_${child.id}`] =
								child.listing_pre_values[0].id;
							this.dropdownChooseValue[`selectValue_${item.attr_id}`] =
								child.listing_pre_values[0].value;
						}
					}
				}
			}
		},

		getFile(ev) {
			console.log(ev)
			this.listing.listingImage = ev;
		},

		async getListingForSubmit(removePackage) {
			if (!this.countError) {
				this.$emit('loading', true);

				Object.keys(this.listing.listingAttr.data).forEach(item => {
					const splitID = item.split('_');
					if (splitID[1] == 16) {
						this.listing.price = this.listing.listingAttr.data[
							`inputValue_${splitID[1]}`
						];
					}
				});
				if (this.listing.price.indexOf(',') !== -1) {
					this.listing.price = this.listing.price.replace(/,/g, '');
				}
				// create the listing object
				const listing = {
					title: this.listing.title,
					description: this.listing.description,
					price: +this.listing.price,
					listing_category_id: this.listing.subCategory.id,
					province_id: this.listing.state.id,
					district_id: this.listing.district.id,
					email: this.listing.email,
					phone: this.listing.phoneNumber,
					line_id: this.listing.line_id,
					keywords: this.listing.keywords,
					listingAttr: this.listing.listingAttr,
					package_detail_ids: this.listing.package_detail_ids,
					affiliate_dates_ids: this.listing.affiliate_dates_ids,
					listing_image: this.listing.listingImage,
					website: this.listing.website
				};
				if(removePackage){
					listing.package_detail_ids=[]
					listing.package_detail_ids=null
					listing.website=null
				}
				// Post a new listing
				if (!this.listListingJustCreated.id && this.$route.name === 'AddListing') {
					this.USER_ADD_LISTING(listing)
						.then(item => {
							this.$emit('loading', false);
							let dialog = this.$bvModal.show('listing-preview-dialog-first');

							// this.secondStep = true;
							// this.firstStep = false;
							window.scroll(0, 0);
						})
						.catch(error => {
							
							if (error.data.detail === 'PREBOOKING_DATES_EXPIRED') {
								this.makeToastError(this.$t('packages.datesError'));
							} else {
								this.makeToastError(this.$t('Error one or more fields are invalid'));
							}
							this.$emit('loading', false);
						});
				} else {
					// Update an existing listing
					this.USER_UPDATE_LISTING({
						id: this.$route.params.id,
						...listing
					})
						.then(item => {
							this.$emit('loading', false);
							this.$bvModal.show('listing-preview-dialog-first');
							// this.secondStep = true;
							// this.firstStep = false;
							window.scroll(0, 0);
						})
						.catch(error => {
							if (error.data.detail === 'PREBOOKING_DATES_EXPIRED') {
								this.makeToastError(this.$t('packages.datesError'));
							} else {
								this.makeToastError(this.$t('Error one or more fields are invalid'));
							}
							this.$emit('loading', false);
						});
				}
			} else {
				this.makeToastError(this.$t('Please enter additional details'));
			}
		},
		hideModal(id, category, idCategory, name, cateogryValue) {
			// if main category is changed enable the edit to set default value
			if(idCategory==2){
				window.location.href=cateogryValue.redirect_to+`/th/add-listing?siteUrl=${window.location.origin}&sitetitle=${this.$root.siteTitle}`;
			}
			this.categoryFirstChange = true;
			this.listing.mainCategory.key = category;
			this.listing.mainCategory.idCategory = idCategory;
			this.listing.mainCategory.name = name;
			this.listing.subCategory = null;
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			this.validateInputDynamic = [];
			// this.hideFileUploader = false;
			this.$root.$emit('bv::hide::modal', id);
		},
		getSelectedPackages(ev) {
			console.log("ev",ev)
			let objectID = JSON.parse(JSON.stringify(ev));
			// update package_detail_ids
			this.listing.package_detail_ids = '';
			let arr = [];
			Object.values(ev.packagesValue).forEach(pack => {
				if (pack.packagesDetails) {
					arr.push(pack.packagesDetails.id);
				}
			});
			console.log("arr",arr)
			this.listing.package_detail_ids = arr.toString();
			// update website url
			this.listing.website = objectID.websiteUrl;
			console.log(this.disabled)
			// submit btn disabling
			this.disabled = objectID.disabled;
			let datesArr = [];
			ev.preBookedDates.forEach(date => {
				datesArr.push(date.id);
			});
			this.listing.affiliate_dates_ids = datesArr.toString();
			this.$forceUpdate();
		},
		openThairathLogin() {
			this.$root.signIn('add-listing');
		},
		openPakcageDialog(){
			this.$bvModal.hide('image-ads-model');
			this.checkForm();
			if(!this.countError){
				this.$bvModal.show('package-model');
			}else{
				this.makeToastError(this.$t('Please enter the required details'));
			}
		},
		cancelPackage(){
			this.$bvModal.hide('package-model');
		},
		toggleAdsImag(){
			this.cancelPackage();
			this.$bvModal.show('image-ads-model');
		},
		addPackage(removePackage){
			this.cancelPackage();
			this.$bvModal.hide('image-ads-model');
			this.getListingForSubmit(removePackage);
		},
		skipAddListing() {
			this.$emit('loading', true);
			const payment = this.listListingJustCreated.user_payments;
			this.USER_CONFIRM_LISTING(this.listListingJustCreated.id)
				.then(result => {
					this.$emit('loading', false);
					if (payment && payment.length) {
						let result = payment.find(temp => temp.status == 1);
						if (result) {
							this.$router.push(
								this.$i18nRoute({ name: 'payment' }) + result.id
							);
						} else {
							this.$bvModal.hide('listing-preview-dialog-first');
							this.secondStep = true;
							this.firstStep = false;
							this.$forceUpdate();
						}
					} else {
						this.$bvModal.hide('listing-preview-dialog-first');
						this.secondStep = true;
						this.firstStep = false;
						this.$forceUpdate();
					}
				})
				.catch(error => {
					
					this.$emit('loading', false);
					this.secondStep = false;
					this.firstStep = true;
					this.$forceUpdate();
				});
		},
		checkForm(e) {
			this.countError = 0;
			this.validateErrors = {};
			this.validateInputDynamic = [];
			this.isValidate = true;
			if (this.listing.title && this.listing.title.match(/[\u1000-\uFFFF]+/g)) {
				this.validateErrors[`title`] = true;
				this.countError++;
				this.makeToastError(this.$t('Marks or special characters are not allowed'));
				return;
			}
			if (!this.listing.title) {
				this.validateErrors[`title`] = true;
				this.countError++;
			}
			if (this.listing.mainCategory.idCategory != 4 && !this.listing.price) {
				this.validateErrors[`price`] = true;
				this.countError++;
			}
			if (!this.listing.subCategory || !this.listing.subCategory.id) {
				this.validateErrors[`idSubListing`] = true;
				this.countError++;
			}
			if (!this.listing.description) {
				this.validateErrors[`description`] = true;
				this.countError++;
			}
			if (!this.listing.state) {
				this.validateErrors[`state`] = true;
				this.countError++;
			}
			if (!this.listing.district) {
				this.validateErrors[`district`] = true;
				this.countError++;
			}
			if (!this.listing.email && !this.listing.phoneNumber) {
				this.validateErrors[`phoneAndEmail`] = true;
				this.countError++;
			}

			if (
				(this.listing.listingAttr.data.radioValue_18 &&
					this.listing.listingAttr.data.radioValue_18 == 53) ||
				this.listing.listingAttr.data.radioValue_18 == 54 ||
				this.listing.listingAttr.data.radioValue_18 == 55
			) {
				delete this.listing.listingAttr.data['inputValue_15'];
				delete this.listing.listingAttr.data['inputValue_16'];
				this.$forceUpdate();
			}
			if (Object.keys(this.listing.listingAttr.data).length) {
				Object.keys(this.listing.listingAttr.data).forEach((name, index) => {
					if (this.listing.listingAttr.data[`${name}`]) {
						this.validateInputDynamic.push(name);
						
					} else {
						this.countError++;
						
					}
				});
			}
			if (
				this.listing.mainCategory.idCategory == 1 &&
				Object.keys(this.listing.listingAttr.data).length != 2
			) {
				this.countError++;
			} else if (
				this.listing.mainCategory.idCategory == 2 &&
				Object.keys(this.listing.listingAttr.data).length != 6
			) {
				this.countError++;
			} else if (
				this.listing.mainCategory.idCategory == 3 &&
				Object.keys(this.listing.listingAttr.data).length != 9
			) {
				this.countError++;
			} else if (this.listing.mainCategory.idCategory == 4) {
				
				if (
					this.listing.listingAttr.data.radioValue_18 &&
					this.listing.listingAttr.data.radioValue_18 == 56 &&
					Object.keys(this.listing.listingAttr.data).length != 4
				) {
					this.countError++;
				} else {
					
					if (this.listing.listingAttr.data.inputValue_15&&this.listing.listingAttr.data.inputValue_16&&
						this.listing.listingAttr.data.inputValue_15 ===
						this.listing.listingAttr.data.inputValue_16
					) {
						this.makeToastError(this.$t('The minimum and maximum wages must not be the same'));
						this.countError++;
						this.countError++;
						this.$forceUpdate();
					}

					if (this.listing.listingAttr.data.inputValue_15&&this.listing.listingAttr.data.inputValue_16&&
						parseInt(
							this.listing.listingAttr.data.inputValue_15.replace(/\,/g, ''),
							10
						) >
						parseInt(
							this.listing.listingAttr.data.inputValue_16.replace(/\,/g, ''),
							10
						)
					) {
						
						this.makeToastError(this.$t('The minimum wage must be lower than the highest wage'));
						this.countError++;
						this.$forceUpdate();
					}
				}
			}
			if (!this.listing.listingImage.length) {
				this.validateErrors[`imageError`] = true;
				this.countError++;
				this.makeToastError(this.$t('Please upload a picture'));
				return;
			}
			// this.openPakcageDialog();
			// this.getListingForSubmit();
		},
		makeToastError(text) {
			this.$bvToast.toast(text, {
				title: `Error!`,
				variant: 'danger',
				solid: true
			});
		},
		numberAmountMask() {
			return createNumberMask({
				prefix: '',
				suffix: '',
				allowDecimal: false,
				includeThousandsSeparator: true,
				allowNegative: false
			});
		},
		getListingEdit() {
			this.GET_LISTING_PREVIEW(this.$route.params.id).catch(error => {
				if (error.status == 404) {
					this.$router.push(this.$i18nRoute({ name: '' }));
				}
			});
		},
		previousEditListing() {
			if (this.$route.name === 'AddListing') {
				this.$router.push(
					this.$i18nRoute(
						{ name: 'edit-listing' },
						this.listListingJustCreated ? this.listListingJustCreated.id : null
					)
				);
			}
			this.$bvModal.hide('listing-preview-dialog-first');
			// this.$forceUpdate();
		},
		previewAddListing() {
			if (this.listListingJustCreated) {
				// this.hideFileUploader = true;
				const id = this.listListingJustCreated.id;
				this.GET_LISTING_PREVIEW(id).then(res => {
					
					this.$bvModal.show('preview-model');
				});
			}
		},

		tagValidator(tag) {
			// Individual tag validator function
			return tag === tag && tag.length > 1 && tag.length < 20;
		},
		changeRadioValue(ev, name) {
			this.listing.listingAttr.data[name] = ev;
			this.$forceUpdate();
		},
		ok(){
			this.decodeLatLong();
			this.cancel();
		},
		cancel(){
			this.$bvModal.hide('showgooglemap-model');
		},
		decodeLatLong() {
			this.$gmapApiPromiseLazy().then(() => {
				// eslint-disable-next-line no-undef
				const geocoder = new google.maps.Geocoder()

				geocoder.geocode({ location: { lat: this.markerLat, lng: this.markerLng } }, (results, status) => {
					this.loclationAddress=results[0].formatted_address;
				
				})
			})
		},
		initMap() {
			setTimeout(() => {
				this.$refs.mapRef.$mapPromise.then((map) => {
					this.map = map;
					map.panTo({ lat: this.lat, lng: this.lng });
				});
			}, 200);
		},
		getPosition(ev) {
			this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
			this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
		},
		putMarker(ev) {
			console.log('ev', ev);
			this.markerLat = ev.latLng ? ev.latLng.lat() : ev.lat();
			this.markerLng = ev.latLng ? ev.latLng.lng() : ev.lng();
		}
	}
};
</script>

<style lang="scss">
@import 'editListingDesktop.scss';
#image-ads-model{
.modal-content{
	background:transparent;
	border: none;
}
}
</style>

